import { Box, BoxProps, ColorOptions, Text } from '@jfs/ui-new'
import { useInterval } from '@jfs/utils'
import { FC, useEffect, useRef } from 'react'
import { ViewProps } from 'react-native'
import { customTheme } from '../../util/util'

interface ProgressProps {
  setTimeLeft: (time: number) => void
  hide?: Boolean
  time?: number
  defaultTimerCount?: number
  expiryTime?: Date
}

const ProgressWithTimer: FC<ProgressProps> = ({
  setTimeLeft,
  hide = false,
  time = 30,
  defaultTimerCount,
  expiryTime,
}: ProgressProps) => {
  useEffect(() => {
    if (hide) {
      setTimeLeft(defaultTimerCount)
    }
  }, [hide, setTimeLeft, defaultTimerCount])

  const savedCallback: any = useRef()
  useEffect(() => {
    savedCallback.current = setTimeLeft
  }, [setTimeLeft])

  useInterval(() => {
    if (time >= 1) {
      const diffInSeconds = (expiryTime.getTime() - Date.now()) / 1000
      setTimeLeft(diffInSeconds)
    }
  }, 1000)

  if (hide) {
    return null
  }

  const secondsToMinutes = (duration) => {
    let timerMin = (duration / 60).toString()
    let timerSec = (duration % 60).toString()
    let minutes: any = parseInt(timerMin, 10)
    let seconds: any = parseInt(timerSec, 10)

    minutes = minutes < 10 ? '0' + minutes : minutes
    seconds = seconds < 10 ? '0' + seconds : seconds
    return minutes + ':' + seconds
  }

  let timeInMinutes = secondsToMinutes(time)
  return (
    <Box>
      <Text fontSize={12} fontFamily={'JioType-Medium'} color="WHITE">
        Complete payment within{' '}
        <Text fontFamily={'JioType-Medium'} color={'#FFABB1' as ColorOptions} fontSize={12}>
          {timeInMinutes}
        </Text>
      </Text>
    </Box>
  )
}

const styles = {
  progressView: {
    height: 4,
    width: '100%',
    backgroundColor: 'BRIGHT_SKY',
  } as BoxProps,
  animationStyle: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: customTheme.colors.PRIMARY_STORNG,
    borderRadius: 5,
  } as ViewProps,
}
export { ProgressWithTimer }
